<template>
  <div class="addTrainingCourseAdmin">
    <el-page-header
      content="添加教研活动"
      @back="
        $router.push({
          path: '/background/teachingActivities',
        })
      "
    ></el-page-header>
    <el-form
      class="form-style"
      ref="form"
      :model="form"
      :rules="rules"
      label-width="100px"
      size="small"
      label-position="left"
    >
      <el-form-item label="所属科目">
        <el-select v-model="form.subject_id" placeholder="请选择" clearable>
          <el-option label="公开活动" value=""></el-option>
          <el-option
            v-for="item in subjectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标题" required prop="title">
        <el-input
          placeholder="请输入标题"
          v-model="form.title"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="主持人" required prop="host">
        <el-input
          placeholder="请输入主持人"
          v-model="form.host"
          maxlength="100"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="活动类型" required prop="activity_type">
        <el-select v-model="form.activity_type" placeholder="请选择">
          <el-option
            v-for="item in activityType"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <div class="time">
        <el-form-item label="* 活动时间" class="fl">
          <el-date-picker
            v-model="form.activity_start_date"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            placeholder="选择开始日期"
            placement="bottom-start"
          ></el-date-picker>
        </el-form-item>
        <div class="fl" style="margin: 0 20px">-</div>
        <el-form-item class="fl" label-width="0px">
          <el-date-picker
            v-model="form.activity_end_date"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            placeholder="选择时间"
            placement="bottom-start"
          ></el-date-picker>
        </el-form-item>
      </div>
      <el-form-item label="简要介绍" required prop="brief_content">
        <el-input
          type="textarea"
          v-model="form.brief_content"
          maxlength="400"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="* 封面地址">
        <el-upload
          action
          ref="upload"
          :http-request="uploadFile"
          :on-remove="handleRemove"
          :on-change="handleChangeFile"
          :auto-upload="false"
          :limit="1"
          :on-exceed="handleExceed"
          :file-list="fileList"
          list-type="picture"
          style="width: 400px"
        >
          <el-button size="small" type="primary" plain>点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            <span style="margin-left: 10px">推荐尺寸: 500px * 345px</span>
            <span style="margin-left: 10px"
              >只能上传jpg/png文件，且不超过500kb</span
            >
          </div>
        </el-upload>
      </el-form-item>
      <!-- banner -->

      <el-form-item label="* 轮播图片">
        <el-upload
          action
          ref="upload"
          :http-request="uploadBanner"
          :on-remove="handleRemove2"
          :on-change="handleChangeFile2"
          :auto-upload="false"
          :limit="1"
          :on-exceed="handleExceed2"
          :file-list="fileListBanner"
          list-type="picture"
          style="width: 400px"
        >
          <el-button size="small" type="primary" plain>点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            <span style="margin-left: 10px">推荐尺寸: 1920px * 380px</span>
            <span style="margin-left: 10px"
              >只能上传jpg/png文件，且不超过500kb</span
            >
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="置顶等级" required prop="new_state">
        <el-select v-model="form.new_state" placeholder="请选择">
          <el-option
            v-for="item in newState"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="通知内容" required prop="notice_content">
        <div>
          <MarkDown
            v-if="showmarkdown"
            :markdown="form.notice_content"
            @SaveMarkDown="SaveMarkDown"
          ></MarkDown>
        </div>
      </el-form-item>
      <el-form-item label="活动介绍" required prop="main_content">
        <div>
          <MarkDown
            v-if="showmarkdown1"
            :markdown="form.main_content"
            @SaveMarkDown="SaveMarkDown1"
          ></MarkDown>
        </div>
      </el-form-item>
      <el-form-item label="* 教师提问">
        <div>
          <MarkDown
            v-if="showmarkdown2"
            :markdown="form.tch_question_content"
            @SaveMarkDown="SaveMarkDown2"
          ></MarkDown>
        </div>
      </el-form-item>
      <el-form-item label="* 资料下载">
        <div>
          <MarkDown
            v-if="showmarkdown3"
            :markdown="form.download_content"
            @SaveMarkDown="SaveMarkDown3"
          ></MarkDown>
        </div>
      </el-form-item>

      <el-form-item label="* 群二维码">
        <el-upload
          action
          ref="upload"
          :http-request="uploadFilequn"
          :on-remove="handleRemove1"
          :on-change="handleChangeFile1"
          :auto-upload="false"
          :limit="1"
          :on-exceed="handleExceed1"
          :file-list="fileListqun"
          list-type="picture"
          style="width: 400px"
        >
          <el-button size="small" type="primary" plain>点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            <span style="margin-left: 10px">推荐尺寸: 370px * 260px</span>
            <span style="margin-left: 10px"
              >只能上传jpg/png文件，且不超过500kb</span
            >
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="* 录播地址">
        <el-input
          placeholder="请输入视频地址"
          v-model="form.video_url"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer" style="margin:20px;">
      <el-button size="small" @click="goback">取 消</el-button>
      <el-button size="small" type="primary" @click="submit('form')"
        >确 定</el-button
      >
    </span>
  </div>
</template>

<script>
import MarkDown from '@/components/markdown'
import uploadFile from '@/config/uploadFile'
import uploadFilequn from '@/config/uploadFile'
import uploadBanner from '@/config/uploadFile'

import {
  getAdminSubjectListWithOutPageInfo,
  addCurriculum,
} from '@/api/admin.js'
export default {
  components: {
    MarkDown: MarkDown,
  },
  data() {
    return {
      fileListBanner: [],
      type: '',

      research_activity_id: '',

      showmarkdown: true,
      showmarkdown1: true,
      showmarkdown2: true,
      showmarkdown3: true,
      //课程封面
      newState: [
        {
          value: '0',
          label: '不置顶',
        },
        {
          value: '1',
          label: '1级',
        },
        {
          value: '2',
          label: '2级',
        },
        {
          value: '3',
          label: '3级',
        },
        {
          value: '4',
          label: '4级',
        },

        {
          value: '5',
          label: '5级',
        },
        {
          value: '6',
          label: '6级',
        },
      ],
      activityType: [
        {
          id: '1',
          name: '技能培训',
        },
        {
          id: '2',
          name: '教学技巧',
        },
        {
          id: '3',
          name: '其他分享',
        },
      ],
      subjectList: [],
      startDate: '',
      endDate: '',
      subject_id: '',
      subjectId: '',
      fileList: [],
      fileListqun: [],
      form: {
        banner_img_url: '',
        subject_id: '', //所属科目
        title: '', //标题
        activity_type: '', //活动类型
        activity_date: '', //活动日期
        brief_content: '', //简要介绍
        new_state: '', //置顶等级
        notice_content: '', //通知内容
        main_content: '', //活动介绍，
        tch_question_content: '', //教师提问
        video_url: '', //视频地址
      },
      tableData: [],
      rules: {
        host: [
          {
            required: true,
            message: '请输入主持人',
          },
        ],
        startDate: [
          {
            required: true,
            type: 'date',
            message: '请选择开始时间',
            trigger: 'change',
          },
        ],
        endDate: [
          {
            required: true,
            type: 'date',
            message: '请选择结束时间',
            trigger: 'change',
          },
        ],
        subject_id: [
          {
            required: true,
            message: '请选择科目',
          },
        ],
        title: [
          {
            required: true,
            message: '请输入标题',
          },
        ],
        activity_type: [
          {
            required: true,
            message: '请选择活动类型',
          },
        ],
        activity_date: [
          {
            required: true,
            message: '请选择活动日期',
          },
        ],
        brief_content: [
          {
            required: true,
            message: '请输入简要介绍',
          },
        ],
        new_state: [
          {
            required: true,
            message: '请选择置顶等级',
          },
        ],
        notice_content: [
          {
            required: true,
            message: '请输入通知内容',
          },
        ],
        main_content: [
          {
            required: true,
            message: '请输入活动介绍',
          },
        ],
      },
    }
  },
  created() {
    if (this.$route.query.row != null) {
      console.log(this.$route.query.row, 666666666)
      console.log(JSON.parse(this.$route.query.row).subject_id, 6666)
      JSON.parse(this.$route.query.row)
      this.research_activity_id = JSON.parse(this.$route.query.row).id
      this.form.notice_content = JSON.parse(
        this.$route.query.row
      ).notice_content
      this.form.main_content = JSON.parse(this.$route.query.row).main_content
      this.form.tch_question_content = JSON.parse(
        this.$route.query.row
      ).tch_question_content
      this.form.download_content = JSON.parse(
        this.$route.query.row
      ).download_content
    }
  },
  watch: {
    'form.subject_id'(val) {
      if (val === null) {
        this.form.subject_id = ''
      }
    },
  },
  mounted() {
    this.getAdminSubjectListWithOutPageInfo()

    this.getinfo()
  },
  methods: {
    goback() {
      this.$router.go(-1)
    },
    getinfo() {
      this.type = this.$route.query.act
      if (this.type != 'add') {
        this.form = JSON.parse(this.$route.query.row)
        this.fileList.push({
          url: JSON.parse(this.$route.query.row).img_url,
        })
        this.fileListqun.push({
          url: JSON.parse(this.$route.query.row).group_img_url,
        })
        console.log(
          JSON.parse(this.$route.query.row).banner_img_url,
          66666666666666666
        )
        if (JSON.parse(this.$route.query.row).banner_img_url === '') {
          this.fileListBanner = []
        } else {
          this.fileListBanner.push({
            url: JSON.parse(this.$route.query.row).banner_img_url,
          })
        }

        if (JSON.parse(this.$route.query.row).activity_type === 1) {
          this.form.activity_type = '技能培训'
        }
        if (JSON.parse(this.$route.query.row).activity_type === 2) {
          this.form.activity_type = '教学技巧'
        }
        if (JSON.parse(this.$route.query.row).activity_type === 3) {
          this.form.activity_type = '其他分享'
        }
        if (JSON.parse(this.$route.query.row).new_state === 0) {
          this.form.new_state = '不置顶'
        }
        if (JSON.parse(this.$route.query.row).new_state === 1) {
          this.form.new_state = '1级'
        }
        if (JSON.parse(this.$route.query.row).new_state === 2) {
          this.form.new_state = '2级'
        }
        if (JSON.parse(this.$route.query.row).new_state === 3) {
          this.form.new_state = '3级'
        }
        if (JSON.parse(this.$route.query.row).new_state === 4) {
          this.form.new_state = '4级'
        }
        if (JSON.parse(this.$route.query.row).new_state === 5) {
          this.form.new_state = '5级'
        }
        if (JSON.parse(this.$route.query.row).new_state === 6) {
          this.form.new_state = '6级'
        }
      }
    },

    //通知内容
    SaveMarkDown(md, html) {
      console.log('保存markdown')
      console.log(md)
      console.log(html)
      this.form.notice_content = md
    },
    SaveMarkDown1(md, html) {
      console.log('保存markdown')
      console.log(md)
      console.log(html)
      this.form.main_content = md
    },
    SaveMarkDown2(md, html) {
      console.log('保存markdown')
      console.log(md)
      console.log(html)
      this.form.tch_question_content = md
    },
    SaveMarkDown3(md, html) {
      console.log('保存markdown')
      console.log(md)
      console.log(html)
      this.form.download_content = md
    },
    //banner
    uploadBanner() {},
    async handleChangeFile2(file, fileListBanner) {
      console.log('handleChangeFile2')
      console.log(fileListBanner)

      if (!this.uploadFileTime) {
        await this.uploadFileOss2(fileListBanner)
      }
    },
    async uploadFileOss2(list) {
      this.uploadFileTime = true
      await uploadBanner(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传文件')
          console.log(res)
          res.map((item) => {
            this.form.banner_img_url = item.url
            console.log(item.url)
          })

          this.fileListBanner = res
          this.uploadFileTime = false
          console.log(this.$refs.form, '555555555')
          this.$nextTick(() => {
            this.rules.fileUpdate1 = []
          })
        }
      )
    },
    handleRemove2(file, fileListBanner) {
      console.log(file, fileListBanner)
    },

    handleExceed2() {
      this.$message.warning('请删除原有文件,再重新上传')
    },

    // 群地址
    uploadFilequn() {},
    async handleChangeFile1(file, fileListqun) {
      console.log('handleChangeFile1')
      console.log(fileListqun)

      if (!this.uploadFileTime) {
        await this.uploadFileOss1(fileListqun)
      }
    },
    async uploadFileOss1(list) {
      this.uploadFileTime = true
      await uploadFilequn(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传文件')
          console.log(res)
          res.map((item) => {
            this.form.group_img_url = item.url
            console.log(item.url)
          })
          this.fileListqun = res
          this.uploadFileTime = false
          console.log(this.$refs.form, '555555555')
          this.$nextTick(() => {
            this.rules.fileUpdate1 = []
          })
        }
      )
    },
    handleRemove1(file, fileListqun) {
      console.log(file, fileListqun)
    },

    handleExceed1() {
      this.$message.warning('请删除原有文件,再重新上传')
    },

    //课程封面
    uploadFile() {},
    async handleChangeFile(file, fileList) {
      console.log('handleChangeFile')
      console.log(fileList)

      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList)
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传文件')
          console.log(res)
          res.map((item) => {
            this.form.img_url = item.url
            // this.form.group_img_url = item.url;
          })
          this.fileList = res
          this.uploadFileTime = false
          this.rules.fileUpdate = []
        }
      )
    },

    handleRemove(file, fileList) {
      console.log(file, fileList)
    },

    handleExceed() {
      this.$message.warning('请删除原有文件,再重新上传')
    },
    //获取列表
    //获取科目
    getAdminSubjectListWithOutPageInfo() {
      getAdminSubjectListWithOutPageInfo({
        subject_state: 1,
      }).then((res) => {
        console.log(res)
        this.subjectList = res.subject_list
      })
    },
    //新增编辑
    submit(form) {
      if (this.form.new_state === '不置顶') {
        this.form.new_state = 0
      }
      if (this.form.new_state === '1级') {
        this.form.new_state = 1
      }
      if (this.form.new_state === '2级') {
        this.form.new_state = 2
      }
      if (this.form.new_state === '3级') {
        this.form.new_state = 3
      }
      if (this.form.new_state === '4级') {
        this.form.new_state = 4
      }
      if (this.form.new_state === '5级') {
        this.form.new_state = 5
      }
      if (this.form.new_state === '6级') {
        this.form.new_state = 6
      }
      if (this.form.activity_type === '技能培训') {
        this.form.activity_type = 1
      }
      if (this.form.activity_type === '教学技巧') {
        this.form.activity_type = 2
      }
      if (this.form.activity_type === '其他分享') {
        this.form.activity_type = 3
      }
      if (this.fileList.length === 0) {
        this.$message.warning('请上传封面图片')
      } else if (this.fileListqun.length === 0) {
        this.$message.warning('请上传群图片')
      } else {
        this.$refs[form].validate((valid) => {
          if (valid) {
            if (this.type === 'add') {
              console.log(this.form.activity_end_date, 4444444444444444444)
              this.form.activity_end_date.substr(0, 16)
              this.form.activity_date =
                this.form.activity_start_date +
                '-' +
                this.form.activity_end_date.substr(10, 13)
              console.log(this.startDate)
              console.log(this.endDate)
              console.log(this.form.activity_date)
              addCurriculum({
                ...this.form,
              }).then((res) => {
                console.log(res)
                this.$message.success('创建成功')
                this.$router.push({ path: '/background/teachingActivities' })
              })
            } else {
              addCurriculum({
                research_activity_id: this.research_activity_id,
                ...this.form,
              }).then(() => {
                this.$message.success('修改成功！')
                this.$router.push({ path: '/background/teachingActivities' })

                console.log(this.form, 45546456)
              })
            }
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.addTrainingCourseAdmin {
  height: 100%;
  min-height: 100vh;
  background-color: #fff;
  margin: 10px;
  padding: 15px;
  border-radius: 5px;

  .form-style {
    margin-left: 15px;
  }

  .table-style {
    margin-top: 15px;
  }
}

.time {
  overflow: hidden;
}

.fl {
  float: left;
}
</style>
